//
import type { ThemeColorPresetsValue } from './types';

// theme
import palette from '../../theme/palette';

// ----------------------------------------------------------------------

const themePalette = palette('light');

export const presets = [
  // DEFAULT
  {
    name: 'default',
    ...themePalette.primary,
  },
  // CYAN
  {
    contrastText: '#FFFFFF',
    dark: '#0351AB',
    darker: '#012972',
    light: '#68CDF9',
    lighter: '#CCF4FE',
    main: '#078DEE',
    name: 'cyan',
  },
  // PURPLE
  {
    contrastText: '#FFFFFF',
    dark: '#431A9E',
    darker: '#200A69',
    light: '#B985F4',
    lighter: '#EBD6FD',
    main: '#7635dc',
    name: 'purple',
  },
  // BLUE
  {
    contrastText: '#FFFFFF',
    dark: '#103996',
    darker: '#061B64',
    light: '#76B0F1',
    lighter: '#D1E9FC',
    main: '#2065D1',
    name: 'blue',
  },
  // ORANGE
  {
    contrastText: themePalette.grey[800],
    dark: '#B66816',
    darker: '#793908',
    light: '#FED680',
    lighter: '#FEF4D4',
    main: '#fda92d',
    name: 'orange',
  },
  // RED
  {
    contrastText: '#FFFFFF',
    dark: '#B71833',
    darker: '#7A0930',
    light: '#FFC1AC',
    lighter: '#FFE3D5',
    main: '#FF3030',
    name: 'red',
  },
];

export const defaultPreset = presets[0];
export const cyanPreset = presets[1];
export const purplePreset = presets[2];
export const bluePreset = presets[3];
export const orangePreset = presets[4];
export const redPreset = presets[5];

export const presetsOption = presets.map((color) => ({
  name: color.name,
  value: color.main,
}));

export const getPresets = (key: ThemeColorPresetsValue) => {
  return {
    blue: bluePreset,
    cyan: cyanPreset,
    default: defaultPreset,
    orange: orangePreset,
    purple: purplePreset,
    red: redPreset,
  }[key];
};
